/** Dropdown options for Hirelane shortlist / reject confirmation modals (must match API allow-lists). */

export const HIRELANE_REJECT_REASONS = [
  'Insufficient experience',
  'Missing critical technical skills',
  'Location / work mode mismatch',
  'Compensation mismatch',
  'Notice period concern',
  'Weak project relevance',
  'Poor domain fit',
  'Not suitable for this role',
  'Other'
];

export const HIRELANE_SHORTLIST_REASONS = [
  'Strong technical match',
  'Strong domain experience',
  'Good architecture exposure',
  'Good leadership potential',
  'Meets core role requirements',
  'Worth technical discussion',
  'Cony recommendation accepted',
  'Other'
];

export const HIRELANE_SHORTLIST_NEXT_STEPS = [
  'Recruiter screening',
  'Technical interview',
  'Architect interview',
  'Client discussion',
  'Compensation discussion',
  'Hold for later'
];
